import { ITieuDeBaoCao } from "../../../model/response/category/ITieuDeBaoCao";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTieuDeBaoCaoActionsObj = {
    LOAD_START: "",
    LOAD_SUCCESS: {} as ITieuDeBaoCao[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as ITieuDeBaoCao | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as ITieuDeBaoCao,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: "",
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
}

export const eTieuDeBaoCaoActionIds = generateActionTypeIds(eTieuDeBaoCaoActionsObj, "TIEU_DE_BAO_CAO");
export type ITieuDeBaoCaoActionTypes = IGenericActionType<typeof eTieuDeBaoCaoActionsObj, "TIEU_DE_BAO_CAO">;